import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/entities/categories',
    name: RouteName.Categories,
    component: () => import('@/pages/Categories/CategoriesList'),
    meta: {
      breadcrumb: {
        label: 'Категории',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/entities/categories/create',
    name: 'categoryCreate',
    component: () => import('@/pages/Categories/CategoriesCreate'),
    meta: {
      breadcrumb: {
        label: 'Новая категория',
        parent: RouteName.Categories,
      },
    },
  },
  {
    path: '/entities/categories/:id',
    name: 'categoryEdit',
    component: () => import('@/pages/Categories/CategoriesSingle'),
    meta: {
      breadcrumb: {
        label: 'Редактирование категории',
        parent: RouteName.Categories,
      },
    },
    props: { isEdit: false },
  },
]
